export default "__VITE_ASSET__f6e4da90__"